import { EliteLandingPageState } from './types/misc.types'
import { ChangeDirection, EliteScoreTrends, EliteScoresTypes } from './types/mutual-fund-detail.types'

export const RUPEE_SYMBOL = '₹'
export const MUTUAL_FUND_DETAIL_IMAGE_URL = '/images/mf-l2'
export const MUTUAL_FUND_DETAIL_RIVE_URL = '/rives/mf-l2'
export const FD_IMAGE_URL = '/images/fd'
export const MF_EXECUTION_IMAGE_URL = '/images/mf-execution'
export const ELITE_RIVE_URL = '/rives/elite'
export const associatedColours: { [x: string]: { label: string; color: string; isColorInUse: boolean } } = {
  FINANCIAL_SERVICES: { label: 'Financial Services', color: '#1E90FF', isColorInUse: false },
  INFORMATION_TECHNOLOGY: { label: 'Information Technology', color: '#FFD700', isColorInUse: false },
  ENERGY: { label: 'Energy', color: '#FF4500', isColorInUse: false },
  HEALTHCARE: { label: 'Healthcare', color: '#32CD32', isColorInUse: false },
  CONSUMER_STAPLES: { label: 'Consumer Staples', color: '#8A2BE2', isColorInUse: false },
  CONSUMER_DISCRETIONARY: { label: 'Consumer Discretionary', color: '#FF69B4', isColorInUse: false },
  INDUSTRIALS: { label: 'Industrials', color: '#4682B4', isColorInUse: false },
  MATERIALS: { label: 'Materials', color: '#D2691E', isColorInUse: false },
  UTILITIES: { label: 'Utilities', color: '#708090', isColorInUse: false },
  TELECOMMUNICATIONS: { label: 'Telecommunications', color: '#FF6347', isColorInUse: false },
  REAL_ESTATE: { label: 'Real Estate', color: '#6A5ACD', isColorInUse: false },
  COMMUNICATION_SERVICES: { label: 'Communication Services', color: '#2E8B57', isColorInUse: false },
  AGRICULTURE: { label: 'Agriculture', color: '#228B22', isColorInUse: false },
  INFRASTRUCTURE: { label: 'Infrastructure', color: '#20B2AA', isColorInUse: false },
  TEXTILES: { label: 'Textiles', color: '#DA70D6', isColorInUse: false },
  HOSPITALITY: { label: 'Hospitality', color: '#F4A460', isColorInUse: false },
  LARGE_CAP: { label: 'Large Cap', color: '#3E6CE3', isColorInUse: false },
  GLOBAL_OTHER: { label: 'Global Equity', color: '#3E6CE3', isColorInUse: false },
  MID_CAP: { label: 'Mid Cap', color: '#31B7F5', isColorInUse: false },
  SMALL_CAP: { label: 'Small Cap', color: '#2A9C4A', isColorInUse: false },
  AAA: { label: 'AAA', color: '#3E6CE3', isColorInUse: false },
  AA: { label: 'AA', color: '#3188BA', isColorInUse: false },
  A: { label: 'A', color: '#31B7F5', isColorInUse: false },
  BBB: { label: 'BBB', color: '#FFD700', isColorInUse: false },
  BB: { label: 'BB', color: '#FFA100', isColorInUse: false },
  B: { label: 'B', color: '#FF7300', isColorInUse: false },
  BELOW_B: { label: 'Below B', color: '#BA2222', isColorInUse: false },
  NOT_RATED: { label: 'Not Rated', color: '#D1D6D6', isColorInUse: true },
  FLEXI_CAP: {
    label: 'Flexi Cap',
    color: '#E3EEFF',
    isColorInUse: false
  },
  ELSS_TAX_SAVINGS: {
    label: 'ELSS',
    color: '#E3EEFF',
    isColorInUse: false
  },
  VALUE_AND_CONTRA: {
    label: 'Value & Contra',
    color: '#E3EEFF',
    isColorInUse: false
  },
  FOCUSED_FUND: {
    label: 'Focused',
    color: '#E3EEFF',
    isColorInUse: false
  },
  LARGE_AND_MID_CAP: {
    label: 'Large & Mid Cap',
    color: '#E3EEFF',
    isColorInUse: false
  },
  MULTI_CAP: {
    label: 'Multi Cap',
    color: '#E3EEFF',
    isColorInUse: false
  }
}

export const changeStyle = {
  [ChangeDirection.POSITIVE]: {
    icon: `${MUTUAL_FUND_DETAIL_IMAGE_URL}/positive-triangle-icon.svg`,
    // #188659 ≥4.5:1 on white (was #2A9C4A ~3.5:1) — Details_B01 / StyledAmount light gain
    className: 'text-[#188659]',
    sign: '+'
  },
  [ChangeDirection.NEGATIVE]: {
    icon: `${MUTUAL_FUND_DETAIL_IMAGE_URL}/negative-triangle-icon.svg`,
    className: 'text-[#E77464]',
    sign: '-'
  },
  [ChangeDirection.NEUTRAL]: {
    icon: `${MUTUAL_FUND_DETAIL_IMAGE_URL}/neutral-triangle-icon.svg`,
    // #6A6E6E ≥4.5:1 on white (was #8E9393 ~3.1:1) — Details_B01
    className: 'text-[#6A6E6E]',
    sign: ''
  }
}

// @ts-ignore
export const eliteLandingPageStateConfig: {
  [key in `${EliteLandingPageState}`]: { buttonText: string; supportText?: string; isDisabled?: true }
} = {
  [EliteLandingPageState.ONB_NOT_INITIATED]: {
    buttonText: 'Upgrade to Elite'
  },
  [EliteLandingPageState.ONB_IN_PROGRESS]: {
    buttonText: 'Upgrade to Elite'
  },
  [EliteLandingPageState.PAYMENT_NOT_INITIATED]: {
    buttonText: 'Upgrade to Elite'
  },
  [EliteLandingPageState.PAYMENT_PENDING]: {
    buttonText: 'Upgrade to Elite',
    isDisabled: true,
    supportText:
      'Awaiting payment confirmation from your bank. If payment fails, the money will be refunded within 3 working days.'
  },
  [EliteLandingPageState.RE_INITIATE_PAYMENT]: {
    buttonText: 'Retry Payment',
    supportText:
      'Your last payment has failed. Any money deducted will be refunded within 3 working days. You can retry payment to complete your purchase.'
  },
  [EliteLandingPageState.REFUND_PENDING]: {
    buttonText: 'Upgrade to Elite',
    supportText: 'Your membership has been cancelled. Refund will be credited in 5-7 working days.'
  },
  [EliteLandingPageState.PAYMENT_COMPLETED_SUBSCRIPTION_PENDING]: {
    buttonText: 'Complete eSign',
    supportText: 'Your payment was successful. Complete eSign to activate your Elite membership.'
  },
  [EliteLandingPageState.PAYMENT_COMPLETED_SUBSCRIPTION_PENDING_WARNING]: {
    buttonText: 'Complete eSign',
    supportText:
      'Your payment was successful. Complete eSign before {activationExpiryDate} to activate your Elite membership.'
  },
  [EliteLandingPageState.REFUND_DUE_TO_ESIGN_PENDING]: {
    buttonText: 'Upgrade to Elite',
    supportText:
      'Your Elite membership could not be activated as the eSign was not completed in time. The refund has been initiated and will be credited to source in 3-5 days.'
  },
  [EliteLandingPageState.ELITE]: {
    isDisabled: true,
    buttonText: 'Something went wrong'
  },
  [EliteLandingPageState.PAYMENT_FAILED]: {
    buttonText: 'Retry Payment',
    supportText:
      'Your last payment has failed. Any money deducted will be refunded within 3 working days. You can retry payment to complete your purchase.'
  },
  [EliteLandingPageState.FAMILY_ONBOARDING_NOT_ALLOWED]: {
    buttonText: 'Upgrade to Elite'
  },
  [EliteLandingPageState.PLAN_EXPIRED]: {
    buttonText: 'Renew Elite'
  },
  [EliteLandingPageState.ELITE_PAYMENT_COMPLETED_PRIME_PENDING]: {
    buttonText: 'Elite payment pending',
    isDisabled: true
  }
}

export const eliteScoresEnumKeyMapping: Record<
  `${EliteScoresTypes}`,
  'returnsScoreList' | 'stabilityScoreList' | 'recencyScoreList'
> = {
  [EliteScoresTypes.CONSISTENCY]: 'returnsScoreList',
  [EliteScoresTypes.VOLATILITY]: 'stabilityScoreList',
  [EliteScoresTypes.RECENCY]: 'recencyScoreList'
}

export const performanceTagMetaData = {
  [EliteScoreTrends.GREAT]: {
    label: 'Great',
    color: '#FFD4A8',
    textColor: '#4B1600',
    projectedRange: [76, 100],
    actualRange: [80, 100]
  },
  [EliteScoreTrends.GOOD]: {
    label: 'Good',
    color: '#FFDDBD',
    textColor: '#4B1600',
    projectedRange: [51, 75],
    actualRange: [65, 79]
  },
  [EliteScoreTrends.AVERAGE]: {
    label: 'Average',
    color: '#FFE9D4',
    textColor: '#4B1600',
    projectedRange: [26, 50],
    actualRange: [50, 64]
  },
  [EliteScoreTrends.BAD]: {
    label: 'Bad',
    color: '#FFF0E1',
    textColor: '#4B1600',
    projectedRange: [0, 25],
    actualRange: [0, 49]
  }
}

export const iosUpdateApp = {
  type: 'CTA',
  ctaType: 'WEB_REDIRECT',
  navigationStyle: 'NONE',
  url: 'https://itunes.apple.com/app/id6470202376'
}

export const androidUpdateApp = {
  type: 'CTA',
  ctaType: 'WEB_REDIRECT',
  navigationStyle: 'NONE',
  url: 'https://play.google.com/store/apps/details?id=money.powerup.uni.invest.app&hl=en_IN'
}

// UPI handles from NPCI 3rd Party Apps
export const UPI_HANDLES = [
  // Google Pay handles
  '@okhdfcbank',
  '@okaxis',
  '@okicici',
  '@oksbi',
  '@okyesbank',

  // PhonePe handles
  '@ybl',
  '@ibl',
  '@axl',

  // Paytm handles
  '@paytm',
  '@ptyes',
  '@ptaxis',
  '@pthdfc',
  '@ptsbi',

  // BHIM
  '@upi',

  // Airtel Payments Bank
  '@airtel',

  // WhatsApp handles
  '@waicici',
  '@icici',
  '@waaxis',
  '@wahdfcbank',
  '@wasbi',

  // Amazon Pay
  '@apl',
  '@yapl',
  '@rapl',

  // Bajaj Finserv
  '@abfspay',

  // BharatPe
  '@bpunity',

  // ChangeJar
  '@jarunity',

  // CRED
  '@axisb',
  '@yescred',

  // Curie Money
  '@yescurie',

  // FamApp
  '@yesfam',

  // Fi Money
  '@fifederal',

  // Flipkart UPI
  '@fkaxis',

  // Freo
  '@freoicici',

  // Freecharge
  '@fcaxis',

  // Groww
  '@yesg',

  // IND Money
  '@inhdfc',

  // Jupiter Money
  '@jupiteraxis',

  // Kiwi
  '@goaxb',

  // Kredit Bee
  '@kbaxis',

  // Kredit.Pe
  '@kphdfc',

  // LXME
  '@lxaxis',

  // MobiKwik
  '@ikwik',
  '@mknsdlpb',

  // Money View
  '@mvhdfc',

  // Navi
  '@naviaxis',
  '@naviyes',

  // Niyo Global
  '@niyoicici',

  // One Card
  '@oneyes',

  // POPclub
  '@yespop',

  // Rio Money
  '@rmrbl',

  // Samsung Pay
  '@pingpay',

  // salaryse
  '@seyes',

  // Saathi - PayNearby
  '@pnyes',

  // Shriram One
  '@shriramhdfcbank',

  // super.money
  '@superyes',

  // Tata Neu
  '@tapicici',

  // TimePay
  '@timecosmos',

  // T Wallet
  '@axisbank',

  // Twid Pay
  '@yestp',

  // Ultracash
  '@idfcbank',

  // Aditya Birla Capital
  '@abcdicici',

  // Jio Pay (inferred/common)
  '@jio',
  '@jpay',

  // General bank handles
  '@hdfcbank',
  '@sbi',
  '@yesbank',
  '@kotak',
  '@indus'
]

export const OTP_VERIFICATION_DELAY = 650

export const PromiseStatus = {
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
} as const
